export class Stories {
    static moduleName = 'stories';
    static moduleEntityName = 'storiesEntity';
    static listTitle = 'Список историй';
    static createTitle = 'Добавление новой истории';
    static apiPrefix = 'stories';
}